const H = {
  name: "Franchisors",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.7808 0H6.21922L5 4.87689V14H7.09136L4.32212 18H0V24H6V19.09L9.52388 14H11V18H9V24H15V18H13V14H14.4648L18 19.3028V24H24V18H19.5352L16.8685 14H19V4.87689L17.7808 0ZM13 5H11V2H13V5ZM9 2V5H7.03078L7.78078 2H9ZM15 5V2H16.2192L16.9692 5H15ZM7 7H17V12H7V7ZM2 22V20H4V22H2ZM11 20H13V22H11V20ZM20 22V20H22V22H20Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Franchisors
};
